import React from 'react';

import { getCompanyUserCoreRequest } from '@vyce/core/src/api/companies';
import { getPassportRequest as getPayPassportRequest, getRtwRequest as getPayRtwRequest } from '@vyce/core/src/api/pay';
import { TEAMS_PERMISSIONS } from '@vyce/core/src/types';
import { usePermissions } from '@vyce/core/src/hooks/usePermissions';

import { TeamMemberPreview } from '../../teams/components/TeamMemberPreview';

// Declared at module level on purpose: EmployerRoute renders via
// React.createElement(component, props), so an inline arrow in `component={}` would be a new
// component type on every render and would remount the whole preview.
export const DashboardUserPreview: React.FC = () => {
  const { canAnywhere } = usePermissions();
  // The dashboard serves both modules. The teams document routes require
  // can_view_worker_documents; payroll roles only hold can_view_worker_profiles,
  // which the pay document routes accept.
  const withTeamsDocuments = canAnywhere(TEAMS_PERMISSIONS.CAN_VIEW_WORKER_DOCUMENTS);

  return (
    <TeamMemberPreview
      getUserRequest={getCompanyUserCoreRequest}
      getPassportRequest={withTeamsDocuments ? undefined : getPayPassportRequest}
      getRtwRequest={withTeamsDocuments ? undefined : getPayRtwRequest}
    />
  );
};
